import InternalStaticAnchorAchievementList from 'models/application/anchor/types/internalStatic/types/AchievementList';

export default class InternalStaticAnchorAchievementListService {
	toModel(anchor) {
		return new InternalStaticAnchorAchievementList(anchor);
	}
}
